import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    bankRequest: ['bankId'],
    bankAllRequest: ['countryId'],
    linkedBanksRequest: ['provider', 'bankType'],
    bankFilterRequest: ['businessId', 'query', 'options'],

    bankSuccess: ['bank'],
    bankAllSuccess: ['banks'],
    linkedBanksSuccess: ['linkedBanks'],
    bankFilterSuccess: ['filteredBanks'],

    bankFailure: ['error'],
    bankAllFailure: ['error'],
    linkedBanksFailure: ['error'],
    bankFilterFailure: ['error']
})

export const BankTypes = Types
export default Creators
